import { axiosClient } from '@services/clients'

export async function newTransactionLimit(dataT, networkId) {
  const data = await axiosClient.post('/transaction-limit', {
    ...dataT,
    network_id: networkId,
  })
  return data
}

export async function editTransactionLimit(dataT, networkId) {
  const data = await axiosClient.patch(
    `/transaction-limit/network/${networkId}`,
    dataT,
  )
  return data
}

export async function newTransactionLimitByPeriod(dataT, networkId, period) {
  const data = await axiosClient.post(
    `/transaction-limit/network/${networkId}/${period}`,
    dataT,
  )
  return data
}

export async function editTransactionLimitByPeriod(dataT, networkId, period) {
  const data = await axiosClient.patch(
    `/transaction-limit/network/${networkId}/${period}`,
    dataT,
  )
  return data
}

export async function deleteTransactionLimit(
  networkId,
  transactionLimitType,
  currencyCode,
  type,
) {
  // `transactionLimitType` is the PATH segment (e.g. 'deposit'), unchanged.
  // `type` is an OPTIONAL query param used by the RTS delete to target a
  // specific limit type (gross_deposit / true_loss) via the same route
  // (PHOENIX-692). Built with URLSearchParams so values are encoded and the
  // net-deposit delete (no `type`) keeps its original `?currency=` URL.
  const params = new URLSearchParams()
  if (currencyCode) params.set('currency', currencyCode)
  if (type) params.set('type', type)
  const queryString = params.toString()

  const { data } = await axiosClient.delete(
    `/transaction-limit/network/${networkId}/${transactionLimitType}${
      queryString ? `?${queryString}` : ''
    }`,
  )
  return data
}

export async function getTransactionLimit(networkId) {
  try {
    const {
      data: { result },
    } = await axiosClient(`/transaction-limit/network/${networkId}`, {
      headers: {
        'x-network': networkId,
      },
    })

    return Promise.resolve(result)
  } catch (err) {
    console.error(err)
    return Promise.reject(err)
  }
}
